import { format } from 'date-fns/format'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type DateBlockProps = {
  date: string | number | Date
  className?: string
}

const DateBlock = ({ date, className }: DateBlockProps) => {
  const formattedDate = date instanceof Date ? date : new Date(date)
  const time = format(formattedDate, 'hh:mm aaa')
  const generalDate = format(formattedDate, 'MMM dd, y')

  const rows = [generalDate, time]

  return (
    <div className={classNames('flex flex-col items-start md:items-end pt-6', className)}>
      {rows.map((text) => (
        <h5 key={text} className="typography-body-xxl text-primary-800 mb-2 md:text-right">
          {text}
        </h5>
      ))}
    </div>
  )
}

export default DateBlock
